import { isPointInPolygon } from "geolib";

import { getIsValidStationLocation, IStationDto } from "@ryde/shared";

import { MIN_POLYGON_POINTS } from "./stations-map.constants";

/**
 * Ids of the given stations whose location falls inside the drawn ring.
 *
 * Takes plain `[lat, lng]` pairs rather than a map layer, so the point-in-polygon test no longer has to
 * know which engine drew the lasso — the Leaflet version read the ring back off an `L.Polygon` and had to
 * unwrap its multi-ring nesting first.
 */
export const getStationIdsInsideRing = (
  stations: IStationDto[],
  ring: [number, number][],
): number[] => {
  if (ring.length < MIN_POLYGON_POINTS) {
    return [];
  }

  const polygon = ring.map(([latitude, longitude]) => ({
    latitude,
    longitude,
  }));

  return stations
    .filter(station => {
      const location = station.metadata?.locationInfo;

      return (
        getIsValidStationLocation(location) &&
        isPointInPolygon(
          { latitude: location.latitude, longitude: location.longitude },
          polygon,
        )
      );
    })
    .map(station => station.id);
};
